export function escapeRegex(string) {
    return string.replace(/([.*+?^=!:${}()|[\]/\\])/g, '\\$1');
}

export function ignoreSpecialCharacters(string) {
    return string.replace(/([.*+?^=!:${}()|[\]/\\])/g, '');
}
